$( document ).ready(function() {
  
  	function pwSidebarCart(){
      
       setTimeout(function(){ 
       var checkExist = setInterval(function() {
       if ($('#cart .dropdown-menu').is(":visible")) {
          
          var textArray = $(".cart-row .info-item .product-personalisation:contains('PersonalisationID')");
         
          textArray.each(function() {
            var str = $(this).text();
			$(this).text($.trim(str.replace(/[\t\n]+/g,' ')));
            var cardID = this.innerText.match(/PersonalisationID:.*/);
            
            cardID = cardID[0];
            cardID = cardID.replace("PersonalisationID:", "").trim();
            cardID = cardID.match(/[^\s]+/);
            cardID = cardID[0];
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://shopify.printzware.com/thumbs/498/"+cardID+".jpg?r="+rand;
            $(this).parent().parent().find("img").attr("src",newSrc);
            $(this).parent().parent().find("img").attr("srcset",newSrc);

          });
         
         clearInterval(checkExist);
        }
         
       }, 100); // check every 100ms


        }, 2000);

       }
     $("#cart button").on("click", function(){
       
          pwSidebarCart();
     });
  
});